import { Card, Divider, Flex, Icon, Number, Space, Text, Title } from "components/common"
import { useTranslation } from "react-i18next"
import theme from "utils/themeVars"
import styles from "../index.module.less"

const PaymentTermsTable = ({ project }) => {
  const { t } = useTranslation()
  const { bookingDetails } = project
  const priceRange = project?.priceRange
  const startingPrice = project?.bookingDetails?.minInstallmentPerMonth
  const isAmount = bookingDetails?.tokenUnit === "amount"

  const getValue = value => {
    if (!value) return "-"

    return isAmount ? <Number tooltip isCurrency isStringOnly value={value} /> : `${value}%`
  }

  return (
    <Card className={styles.paymentTermsCard} bordered={false} bodyStyle={{ padding: 0 }}>

      <Flex vertical gap={"2px"} className={styles.paymentCardHeader}>
        <Space size={8} align="center">
          {priceRange && (
            <>
              <Icon
                style={{ color: theme["primary-color"] }}
                hasBackground={false}
                size={20}
                icon={"IoMdPricetags"}
              />
              <Title level={4}>
                <Number isStringOnly={true} isCurrency={true} value={priceRange?.min} tooltip /> -{" "}
                <Number isStringOnly={true} isCurrency={false} value={priceRange?.max} tooltip />
              </Title>
            </>
          )}
        </Space>
        {startingPrice && (
          <Text type="secondary" style={{ fontSize: "12px"}}>
            {t("Starting from")} <Number isStringOnly={true} isCurrency={true} value={startingPrice} tooltip />
          </Text>
        )}
      </Flex>

      <Divider style={{ margin: 0 }} />

      <Flex justify="space-between" gap="0px" align="center" className="p-16">
        <Flex vertical gap={4} align="start">
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {t("Token")}
          </Text>
          <Text strong style={{ fontSize: "14px", fontWeight: 600 }}>
            {getValue(bookingDetails?.token)}
          </Text>
        </Flex>
        <Divider type="vertical" style={{ borderColor: theme["gray-300"], marginInline: 8, height: "50px" }} />

        <Flex vertical gap={4} align="start">
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {t("PDP")}
          </Text>
          <Text strong style={{ fontSize: "14px", fontWeight: 600 }}>
            {bookingDetails?.pdp + "%"}
          </Text>
        </Flex>

        <Divider type="vertical" style={{ borderColor: theme["gray-300"], marginInline: 8, height: "50px" }} />

        <Flex vertical gap={4} align="start">
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {t("CDP")}
          </Text>
          <Text strong style={{ fontSize: "14px", fontWeight: 600 }}>
            {bookingDetails?.cdp + "%"}
          </Text>
        </Flex>
        <Divider type="vertical" style={{ borderColor: theme["gray-300"], marginInline: 8, height: "50px" }} />

        <Flex vertical gap={4} align="start">
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {t("Max Term")}
          </Text>
          <Text strong style={{ fontSize: "14px", fontWeight: 600 }}>
            {bookingDetails?.maxInstallmentDuration ? `${bookingDetails?.maxInstallmentDuration} ${t("Months")}` : "-"}
          </Text>
        </Flex>
      </Flex>
    </Card>
  )
}

export default PaymentTermsTable
